import AuthContext from '../contexts/Auth0Context';
import { useContext } from 'react';

export default function useAuth() {
  return useContext(AuthContext);
}
